import React, {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {shallowEqual, useSelector} from 'react-redux';
import SplashScreen from '../../ui/SplashScreen';
import {useGlobalContext} from '../GlobalContext';
import {RootState} from '../../../../store/configureStore';
import {useGlobalMessageContext} from '../GlobalMessageContext';
import {useMessage} from '../useGlobalMessage';
import {useUserSessionContext} from '../UserSessionContext';
import {pathnames as P} from '../../../enums';

const RedirectToForm101 = () => {
  const navigate = useNavigate();
  const {apiService} = useGlobalContext();
  const {currentUser} = useUserSessionContext();
  const globalMessage = useGlobalMessageContext();
  const currentLocale = useSelector((state: RootState) => state.i18n.locale, shallowEqual);
  const M = useMessage();

  useEffect(() => {
    if (currentUser) {
      if (currentUser.agentId) {
        redirectToForm101().catch(() => globalMessage.open(M.serverError));
      } else {
        navigate(P.REG_FORMS);
      }
    }
  }, []);

  const redirectToForm101 = async () => {
    const result = await apiService.getRegFormsState(currentLocale);

    if (result.errorCode < 0) {
      globalMessage.open(M.serverError, () => navigate(P.REG_FORMS));
    } else {
      window.location.href = result.body.status.form101.link;
    }
  };

  return <SplashScreen size={'full'}/>;
};

export default RedirectToForm101;